module.exports = __webpack_public_path__ + "img/screen_third.3a53eee1.png";